import React from 'react';
import { AwardIcon } from 'lucide-react';
import type { Teacher } from '../../types/content';
interface TeacherListProps {
  items: Teacher[];
}
export function TeacherList({
  items
}: TeacherListProps) {
  return <ul className="grid gap-5 md:grid-cols-3" data-id="element-862" data-mp="3cluubueby1m4">
      {items.map(teacher => <li key={teacher.name} className="flex flex-col rounded-[24px] border border-line bg-white p-6" data-id="element-863" data-mp="3glmxfrkyffk3">
          <div className="flex items-center gap-4" data-id="element-864" data-mp="86boh5iqk4q9">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[16px] bg-brand type-h3 text-white" aria-hidden="true" data-id="element-865" data-mp="88xswwaby449">
              {teacher.name.charAt(0)}
            </span>
            <div data-id="element-866" data-mp="3f3b5yeabz7t">
              <h3 className="type-card-title text-ink" data-id="element-867" data-mp="3ek2z9efsp6z">{teacher.name}</h3>
              <p className="mt-1 type-small text-muted" data-id="element-868" data-mp="r57e03jnfuxr">{teacher.role}</p>
            </div>
          </div>
          <p className="mt-5 type-card-desc" data-id="element-869" data-mp="vwfs3cvxc4h9">{teacher.bio}</p>
          <p className="mt-auto flex items-center gap-2 border-t border-line pt-4 type-small font-semibold text-ink" data-id="element-870" data-mp="2vp15gn8pg18p">
            <AwardIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-871" data-mp="2qqgezfj98vxg" />
            {teacher.qualifications}
          </p>
        </li>)}
    </ul>;
}